import React, { useState, useEffect } from "react";
import { Move, X, Swords, Trophy } from 'lucide-react';
import './StartOverlay.css';
import { useTranslation } from 'react-i18next';
import { useGame } from '../utils/GameContext'; 

function StartOverlay({ isVisible = true }) {
    const { t } = useTranslation();
    const { gameMode, setGameMode, challengeData } = useGame();
    const [isTouch, setIsTouch] = useState(true);
    const [isCancelling, setIsCancelling] = useState(false);

    // Detect device type on mount to customize text
    useEffect(() => {
        const checkTouch = () => {
            return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
        };
        setIsTouch(checkTouch());
    }, []);

    const handleCancel = (e) => {
        e.stopPropagation(); 
        setIsCancelling(true);
        // Wait for fade-out animation (0.3s) before switching mode
        setTimeout(() => {
            setGameMode('standard');
            setIsCancelling(false);
        }, 300);
    };

    // Define the start text based on device
    const startText = isTouch ? t('swipeToStart') : "Use Arrow Keys to Start";

    // Determine content based on Game Mode
    const renderContent = () => {
        if (gameMode === 'create_challenge') {
            return (
                <>
                    <div className="mode-icon-wrapper">
                        <Swords size={48} className="c-orange pulse-icon" />
                    </div>
                    <div className="prompt-title">CHALLENGE MODE</div>
                    <div className="prompt-subtitle">Set the target score!</div>
                    <div className="prompt-text small">{startText}</div>
                </>
            );
        }
        
        if (gameMode === 'attempt_challenge' && challengeData) {
            return (
                <>
                    <div className="mode-icon-wrapper">
                        <Trophy size={48} className="c-yellow pulse-icon" />
                    </div>
                    <div className="prompt-title">CHALLENGE ACCEPTED</div>
                    <div className="prompt-subtitle">
                        Beat <span className="highlight-score">{challengeData.scoreToBeat}</span> to win!
                    </div>
                    <div className="prompt-text small">{startText}</div>
                </>
            );
        }

        // Standard Mode - Keeps the original 'Move' (Hand) icon
        return (
            <>
                <Move className="hand-icon" />
                <div className="prompt-text">{startText}</div>
            </>
        );
    };

    return (
        <div className={`start-prompt ${!isVisible || isCancelling ? 'fade-out' : ''}`}>
            {renderContent()}

            {/* Cancel Button - Only visible in challenge modes before start */}
            {gameMode !== 'standard' && (
                <button 
                    className="cancel-challenge-btn" 
                    onClick={handleCancel}
                    onTouchStart={(e) => e.stopPropagation()} 
                    onMouseDown={(e) => e.stopPropagation()}
                >
                    <X size={16} /> CANCEL RUN
                </button>
            )}
        </div>
    );
}

export default StartOverlay;